// @react/hooks/useProjectBoard.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectBoardStore } from '@core/stores';

/**
 * React hook for Board operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectBoard } from '@react/hooks';
 *
 * const BoardList = observer(() => {
 *   const store = useProjectBoard();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectBoard() {
  return projectBoardStore;
}
